import { createSlice } from "@reduxjs/toolkit";
import "firebase/auth";
import { auth } from "../firebase";
import { AuthUser } from "../model/Auth";

export type IAuth = {
  auth: AuthUser;
};

const initialState = {
  auth: setInitialState(),
};

function setInitialState() {
  auth.onAuthStateChanged((authUser) => {
    if (authUser?.uid) {
      return {
        uid: authUser.uid,
        photoUrl: authUser.photoURL,
        displayName: authUser.displayName,
        email: authUser.email,
      };
    } else {
      return {
        uid: "",
        photoUrl: "",
        displayName: "",
        email: "",
      };
    }
  });
  return {
    uid: "",
    photoUrl: "",
    displayName: "",
    email: "",
  };
}

const name = "auth";
const authSlice = createSlice({
  name,
  initialState,
  reducers: {
    login: (state, action) => {
      state.auth = action.payload;
    },
    logout: (state) => {
      state.auth = { uid: "", photoUrl: "", displayName: "", email: ""};
    },
  },
});

export const { login, logout } = authSlice.actions;
export const selectAuth = (state: any) => state.auth.auth;

export const authReducer = authSlice.reducer;
